/**
 * @generated SignedSource<<6e4f10281880431fd13de7f0c589f227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FiltersUsersQuery$variables = {
  userId: string;
};
export type FiltersUsersQuery$data = {
  readonly viewer: {
    readonly sentFeedback: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
        };
      }>;
    } | null;
    readonly sentFeedbackRequest: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isGuest: boolean;
        };
      }>;
    } | null;
    readonly user: {
      readonly internalAttributes: {
        readonly directReports: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly email: string;
              readonly fullName: string;
              readonly id: string;
              readonly image: string;
              readonly isGuest: boolean;
            };
          }>;
        } | null;
      } | null;
    };
  };
};
export type FiltersUsersQuery = {
  response: FiltersUsersQuery$data;
  variables: FiltersUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGuest",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "directReports",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "kind": "Variable",
  "name": "doesNotReportTo",
  "variableName": "userId"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v6 = {
  "alias": "sentFeedback",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "haveFeedbackAbout",
      "value": true
    }
  ],
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "users",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": "sentFeedbackRequest",
  "args": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "sentFeedbackRequest",
      "value": true
    }
  ],
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "users",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiltersUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8650fba1e8737218e543ee9d80dd5efb",
    "id": null,
    "metadata": {},
    "name": "FiltersUsersQuery",
    "operationKind": "query",
    "text": "query FiltersUsersQuery(\n  $userId: ID!\n) {\n  viewer {\n    user {\n      internalAttributes {\n        directReports {\n          edges {\n            node {\n              id\n              fullName\n              email\n              image\n              isGuest\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n    sentFeedback: users(first: 25, haveFeedbackAbout: true, doesNotReportTo: $userId) {\n      edges {\n        node {\n          id\n          fullName\n          email\n          image\n          isGuest\n        }\n      }\n    }\n    sentFeedbackRequest: users(first: 25, sentFeedbackRequest: true, doesNotReportTo: $userId) {\n      edges {\n        node {\n          id\n          fullName\n          email\n          image\n          isGuest\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dac94e36b7d48bd6af8b2b0cd24b68b";

export default node;
